import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import { propertiesRoutes } from "../../app/routes";
import { selectIsCaseWorker } from "../../app/slices";
import { useTypedSelector } from "../../app/stores/store";
import { namespaces } from "../../i18n/i18n.constants";
import { getItemsFromObject } from "../../services/array/transformObject";
import { filterItemRoutesByConfig } from "../../services/routes/filter";
import "./Breadcrumb.scss";
import BreadcrumbItem from "./breadcrumbItem/BreadcrumbItem";

const Breadcrumb = () => {
  const { t } = useTranslation();
  const joinedRoutes = [...filterItemRoutesByConfig(getItemsFromObject(propertiesRoutes))];

  const isCaseWorker = useTypedSelector(selectIsCaseWorker);

  const breadcrumbRoutes = joinedRoutes.map((item) => {
    return {
      path: item.path,
      breadcrumb: BreadcrumbItem,
      props: { name: item.title },
    };
  });

  const breadcrumbs = useBreadcrumbs(breadcrumbRoutes, {
    disableDefaults: true,
  });

  return (
    <div className="row breadcrumb-container">
      <nav aria-label={t("label.breadcrum", { ns: namespaces.aria })} className="row bg-white">
        <ul className="breadcrumb-skat">
          <li key="main" className="breadcrumb-skat_item">
            {isCaseWorker ? (
              <Link to={propertiesRoutes.caseworkerFrontPage.path}>{propertiesRoutes.caseworkerFrontPage.title}</Link>
            ) : (
              <Link to={propertiesRoutes.citizenFrontPage.path}>{propertiesRoutes.citizenFrontPage.title}</Link>
            )}
          </li>
          {breadcrumbs.map(({ breadcrumb }) => breadcrumb)}
        </ul>
      </nav>
    </div>
  );
};

export default Breadcrumb;
